import React from 'react';

import Header from '../Header';

function ContactHeader() {
  return (
    <Header
      title="Contact"
      desc="Reach out to us with your questions or feedback, and we'll get back to you soon!"
    />
  );
}

export default ContactHeader;
